export default "__VITE_ASSET__DOhLc7cx__"